module.exports = __webpack_public_path__ + "img/zip.89822281.png";